import { createContext, useContext } from 'react';

export type DistributionSelectedRange = {
  minPoint: number;
  maxPoint: number;
};

export type DistributionData = {
  range: DistributionSelectedRange;
};

export type UpdateDistributionData = {
  (rangeDataPoint: number): void;
};

export interface GoalGraphContextState {
  distributionData: DistributionData;
  updateDistributionMin: UpdateDistributionData;
  updateDistributionMax: UpdateDistributionData;
}

export const defaultGoalProperties = {
  distributionData: {
    range: {
      minPoint: 90,
      maxPoint: 100,
    },
  },
  // biome-ignore lint/suspicious/noEmptyBlockStatements:
  updateDistributionMin: (_rangeDataPoint: number) => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements:
  updateDistributionMax: (_rangeDataPoint: number) => {},
};

export const GoalGraphContext = createContext<GoalGraphContextState>(defaultGoalProperties);

export const useGoalGraphContext = () => useContext(GoalGraphContext);
